/**
 * @prettier
 * @author Alexander Nagelberg
 *
 **/
import React from 'react'
import { Field, reduxForm } from 'redux-form'

import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import { formatLin, normalizeLin } from 'app/utils/fieldUtils'

const validate = values => {
  const errors = {}

  if (values.firstName && !values.lastName) {
    errors.lastName = 'Must enter first + last name'
  } else if (values.lastName && !values.firstName) {
    errors.firstName = 'Must enter first + last name'
  }

  return errors
}

const SearchForm = ({ handleSubmit, ...props }) => (
  <div className='lgy-funding-fee-search-form'>
    <form autoComplete='off' onSubmit={handleSubmit}>
      <Field label='LIN' name='lin' component={LgyInputField} format={formatLin} normalize={normalizeLin} />
      <div className='usa-grid'>
        <div className='usa-width-one-half'>
          <Field label='First Name' name='firstName' component={LgyInputField} />
        </div>
        <div className='usa-width-one-half'>
          <Field label='Last Name' name='lastName' component={LgyInputField} />
        </div>
      </div>
      <LgyFormSubmit {...props} />
    </form>
  </div>
)

export default reduxForm({ validate })(SearchForm)
